import React from "react";
import { Table } from "reactstrap";
import {
    resolveAssetNameDisplay,
    resolveBuildingNameDisplay,
    resolveRoomDisplay,
} from "../../../../utils/otherValueDisplay";

const VehiclesTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No vehicles recorded.</p>;
    }

    // Calculate unique reference numbers once for color assignment
    const refNumbers = [...new Set(assets.map(asset => asset.reference_number || asset.valuation_ref || "").filter(Boolean))];
    
    // Color palette for alternating groups
    const groupColors = [
        "#e8f0f5", // Light blue-gray - for first reference_number group
        "#ffffff", // White - for second reference_number group
    ];

    return (
        <Table responsive hover bordered className="table-sm">
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
            <tr>
                <th style={{ width: "50px" }}>#</th>
                <th>Reference Number</th>
                <th>Reg / Chassis / Engine</th>
                <th>Make / Model</th>
                <th>Specs (Fuel/Engine)</th>
                <th>Origin & Manufacture</th>
                <th>Location</th>
                <th>Valuer</th>
                <th>Status</th>
                <th>Condition</th>
                <th>Remark</th>
            </tr>
            </thead>
            <tbody>
            {assets.map((a, index) => {
                const condition = a.observed_condition_name || a.observed_condition || "-";

                // Concatenating physical location fields from your schema
                const locationDetails = [
                    resolveBuildingNameDisplay(a, ""),
                    a.floor,
                    resolveRoomDisplay(a, ""),
                ].filter(Boolean).join(", ") || "-";

                // Derive valuer name from related valuation (if present)
                const valuation = a.asset_valuation || a.assetValuation || a.valuation;
                const valuer = valuation?.valuer_user || valuation?.valuerUser;
                const valuerName =
                    a.valuer_name || a.valuerName ||
                    (valuer
                        ? [
                              valuer.first_name || valuer.firstName || "",
                              valuer.middle_name || valuer.middleName || "",
                              valuer.last_name || valuer.lastName || "",
                          ]
                              .filter(Boolean)
                              .join(" ")
                        : "-");

                // Get current reference number
                const currentRef = a.reference_number || a.valuation_ref || "";
                // Get color index for this reference number group
                const refIndex = refNumbers.indexOf(currentRef);
                const colorIndex = refIndex >= 0 ? (refIndex % groupColors.length) : 1;
                const rowBgColor = currentRef ? groupColors[colorIndex] : "#ffffff";
                
                // Add custom CSS class for persistent background
                const rowClassName = currentRef ? `ref-group-${colorIndex}` : "";
                
                // Style for the row: background color only
                const rowStyle = {
                    backgroundColor: rowBgColor
                };

                return (
                    <tr key={a.id} className={rowClassName} style={rowStyle}>
                        <td className="fw-bold text-muted">{index + 1}</td>
                        <td>{a.reference_number || a.valuation_ref || "-"}</td>
                        {/* registration_number, chassis_number, engine_number */}
                        <td>
                            <div className="fw-bold text-primary">{a.registration_number || "-"}</div>
                            <small className="text-muted">Chassis: {a.chassis_number || "-"}</small>
                            <div className="small text-muted">Engine: {a.engine_number || "-"}</div>
                        </td>
                        {/* make and model */}
                        <td>
                            <strong>{a.make} {a.model}</strong>
                            <div className="small text-muted">{resolveAssetNameDisplay(a)}</div>
                        </td>
                        {/* fuel_type and engine_capacity */}
                        <td>
                            <div className="fw-medium">{a.fuel_type || "-"}</div>
                            <small className="text-muted">{a.engine_capacity ? `${a.engine_capacity} cc` : "-"}</small>
                        </td>
                        {/* imported_from and year_of_manufacture */}
                        <td>
                            <div>{a.imported_from || "Local"}</div>
                            <small className="text-muted">Year: {a.year_of_manufacture || "-"}</small>
                        </td>
                        {/* institution_name and location logic */}
                        <td>
                            <div className="small fw-medium">{a.institution_name || "-"}</div>
                            <small className="text-muted">{locationDetails}</small>
                        </td>
                        <td>{valuerName || "-"}</td>
                        <td>{a.status || a.valuation_status || "-"}</td>
                        <td>
                            {condition}
                        </td>
                        <td>{a.remark || "-"}</td>
                    </tr>
                );
            })}
            </tbody>
        </Table>
    );
};

export default VehiclesTab;
